var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-full bg-gray-50 overflow-y-auto",attrs:{"id":"layout"}},[_c('div',{staticClass:"max-w-desktop mx-auto contents",attrs:{"id":"container"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }